import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { Selbstbeteiligung, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { VermietetesBebautesModalObjekt } from '@ps20-frontend/frontend-models';
import { IAppState } from './appState';

export const INITIAL_STATE: IAppState = {
  version: 10,
  risikoort: {
    plz: '',
    ort: '',
    strasse: '',
    hausnummer: '',
  },
  transientState: {
    zurueckZumShopModalOpen: false,
    fehlerCodeTaas: '',
    tarifierungIsInProgress: false,
    priceGuarantee: false,
    role: null,
    vorvertragVorschaeden: null,
    featureToggles: {},
    regexps: {},
    kooperationen: null,
  },
  versicherungsnehmer: {
    geburtsdatum: null,
    familienstand: null,
    isAssekuranztarif: false,
  },
  produkt: null,
  gesamtbeitrag: 0,
  gesamtbeitragMitRabatt: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
  jahresbeitrag: 0,
  vertragsoptionen: {
    selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_0150,
    zahlungsweise: Zahlweise.MONATLICH,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    beginnDatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    aenderungdatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    vorversicherungVorhanden: true,
    isWeitererVertrag: false,
  },
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    aktionsnachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
  },
  rabattstufe: 0,
  antragsnummer: null,
  adressvorschlag: null,
  rechtsstreitigkeiten: {
    vorhanden: null,
    anzahl: 0,
  },
  vermieteteCardObjekte: [
    {
      strassen: [],
      lastError: null,
      orte: [],
      grundstueckBebaut: null,
      hausnummer: null,
      ort: null,
      plz: null,
      strasse: null,
    } as VermietetesBebautesModalObjekt,
  ],
};
